import styled from 'styled-components';

const VideoContentWrapper = styled.div`
  padding: 40px 36px;
  text-align: center;
`;

const VideoTitle = styled.h3`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 500;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  aspect-ratio: 16/9;
`;

const VideoIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
`;

export {
  VideoContentWrapper,
  VideoTitle,
  VideoContainer,
  VideoIframe,
};
